// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormLizingSpecialEquipment
{
	#app;
	#productId = null; // Инициализация свойства для хранения id продукта
	constructor(rootNode, productId): void
	{
		this.rootNode = document.querySelector(rootNode);
		this.#productId = productId;
	}

	// Метод для установки id продукта
	setProductId(productId): void
	{
		this.#productId = productId;
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form  :product-id="productId"/>
				</div>
				`,
			data: () => ({
				productId: this.#productId // Передача id продукта в данные компонента
			}),
		});
		this.#app.mount(this.rootNode);
	}
}
